import { Theme } from "@mui/material";
import { getItemColor, getTheme } from "../material-ui-theme";
import { createEntityStore } from "./entityStore";
import { LandCode } from "./defaultValues";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import updateLocale from "dayjs/plugin/updateLocale";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { LicenseInfo } from "@mui/x-license-pro";
export { dayjs };

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(updateLocale);
dayjs.extend(customParseFormat);

dayjs.updateLocale("en", { weekStart: 1 });

LicenseInfo.setLicenseKey("bfe1df1cc4248913ebbbfcf97517d97cTz02Nzk1OCxFPTE3MTc1OTU0MTAyNTAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=");

export const minPasswordLength = 6;

const initialConfig = localStorage.getItem("config") ? JSON.parse(localStorage.getItem("config")!) : { landCode: "", landName: "", isPet: false };

function getConfig(apiConfig: ApiConfig): Config {
    return {
        ...apiConfig,
        theme: getTheme(apiConfig.isPet),
        itemColor: getItemColor(apiConfig.isPet),
    };
}

export const timeZoneMap: { [landCode in LandCode]: string; } = {
    "CZ": "Europe/Prague",
    "PL": "Europe/Warsaw",
    "SK": "Europe/Bratislava",
    "HU": "Europe/Budapest",
    "EE": "Europe/Tallinn",
    "LV": "Europe/Riga",
    "HR": "Europe/Zagreb",
    "SI": "Europe/Ljubljana",
};

export const useConfig = createEntityStore<Config>({
    path: "config",
    data: getConfig(initialConfig),
    transformFetchedData: getConfig,
    onServerDataChanged(config) {
        const apiConfig = { landCode: config.landCode, landName: config.landName, isPet: config.isPet };
        localStorage.setItem("config", JSON.stringify(apiConfig));
        dayjs.tz.setDefault(timeZoneMap[config.landCode]);
    },
});

interface ApiConfig {
    landCode: LandCode;
    landName: string;
    isPet: boolean;
    tinyMceKey: string | null;
}

interface Config extends ApiConfig {
    theme: Theme;
    itemColor: ReturnType<typeof getItemColor>;
}
